export const getAuthToken = () => localStorage.getItem('authToken') || ''
